export enum DateFormats {
  DEFAULT = 'DD, MMM YYYY',
  DATE_WITH_TIME = 'DD, MMM YYYY, hh:mm a',
}
